import { onMounted, ref, watchEffect } from 'vue'
import { ams_admin_mdm_sites_get } from 'server/modules/2682'
import { Modal } from 'ant-design-vue'
import { useRoute } from 'vue-router'
export const useSites = target => {
  const sites = ref({})
  const routeQuery = useRoute().query
  const { channelId, siteId, brandId, terminalId } = routeQuery

  const getSites = async () => {
    const { success, retInfo, data } = await ams_admin_mdm_sites_get()
    if (success) {
      sites.value = data
    } else {
      Modal.error({ title: retInfo })
    }
  }
  watchEffect(() => {
    if (JSON.stringify(sites.value) !== '{}') {
      Object.assign(target, {
        brandId: +brandId || sites.value.brands[0].id,
        channelId: +channelId || sites.value.channels[0].id,

        siteId: +siteId || sites.value.sites[0].id,
        terminalId: +terminalId || 1
      })
    }
  })
  onMounted(getSites)
  return {
    sites,
    getSites
  }
}
